import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useMobileMenu } from '../../contexts/MobileMenuContext';
import './MobileMenuDrawer.css';

/**
 * Mobile-only slide-down nav drawer. Lives at App level (rendered globally)
 * so it's independent of the navbar's visibility — the navbar itself is
 * hidden on mobile to avoid the iOS status-bar overlap, but this drawer
 * still slides in when MobileMenuContext.toggle is called from anywhere
 * (e.g. the in-page MobilePageBar).
 *
 * Hidden on desktop (CSS @media). Click on overlay or any link closes it.
 */
const MobileMenuDrawer: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { open, close } = useMobileMenu();
  const [trainingExpanded, setTrainingExpanded] = useState(false);
  const [racesExpanded, setRacesExpanded] = useState(false);

  if (!isAuthenticated) return null;

  return (
    <>
      <div
        className={`mobile-menu-overlay ${open ? 'is-open' : ''}`}
        onClick={close}
        aria-hidden={!open}
      />
      <nav className={`mobile-menu-drawer ${open ? 'is-open' : ''}`} aria-hidden={!open}>
        <Link to="/dashboard" className="mobile-menu-drawer__link" onClick={close}>
          Dashboard
        </Link>

        <button
          type="button"
          className="mobile-menu-drawer__group-trigger"
          onClick={() => setTrainingExpanded((v) => !v)}
          aria-expanded={trainingExpanded}
        >
          Training
          <span className={`mobile-menu-drawer__chevron ${trainingExpanded ? 'is-open' : ''}`}>▾</span>
        </button>
        {trainingExpanded && (
          <div className="mobile-menu-drawer__sublinks">
            <Link to="/training-plan" className="mobile-menu-drawer__sublink" onClick={close}>Training Plan</Link>
            <Link to="/workouts" className="mobile-menu-drawer__sublink" onClick={close}>Workouts</Link>
            <Link to="/race-history" className="mobile-menu-drawer__sublink" onClick={close}>Race History</Link>
            <Link to="/race-goal" className="mobile-menu-drawer__sublink" onClick={close}>Race Goal</Link>
            <Link to="/calculator" className="mobile-menu-drawer__sublink" onClick={close}>Pace Calculator</Link>
          </div>
        )}

        <button
          type="button"
          className="mobile-menu-drawer__group-trigger"
          onClick={() => setRacesExpanded((v) => !v)}
          aria-expanded={racesExpanded}
        >
          Races
          <span className={`mobile-menu-drawer__chevron ${racesExpanded ? 'is-open' : ''}`}>▾</span>
        </button>
        {racesExpanded && (
          <div className="mobile-menu-drawer__sublinks">
            <Link to="/races" className="mobile-menu-drawer__sublink" onClick={close}>Find a Race</Link>
            <Link to="/recommend" className="mobile-menu-drawer__sublink" onClick={close}>Race Recommender</Link>
          </div>
        )}

        <Link to="/coach" className="mobile-menu-drawer__link" onClick={close}>
          Coach
        </Link>
      </nav>
    </>
  );
};

export default MobileMenuDrawer;
